<template>
  <div>
    <AttributesMappingGrid
      :attributeNames="attributeNames"
      directionColumnName="JumpCloud to import or export?"
      :directoryName="directoryName"
      :storeName="storeName"
    />
  </div>
</template>

<script>
import {
  DirectoryNameConsts,
  DirectoryTypeConsts,
  StoreModelMap,
} from 'client/util/Constants';
import AttributesMappingGrid from 'client/directories/components/AttributesMappingGrid.vue';

export default {
  name: 'GSuiteAttributesGrid',

  components: { AttributesMappingGrid },

  data: () => ({
    attributeNames: [
      'firstname',
      'lastname',
      'password',
      'email',
      'user_alternate_email',
      'user_home_addresses',
      'user_home_phone_numbers',
      'user_manager',
      'user_mobile_phone_numbers',
      'user_work_addresses',
      'user_work_phone_numbers',
      'user_work_fax_phone_numbers',
      'user_work_mobile_phone_numbers',
      'user_primary_organization_description',
      'user_primary_organization_department',
      'user_primary_organization_employee_id',
      'user_primary_organization_cost_center',
      'user_primary_organization_title',
    ],
    storeName: StoreModelMap[DirectoryTypeConsts.gSuite],
    directoryName: DirectoryNameConsts[DirectoryTypeConsts.gSuite],
  }),
};
</script>
